import React from 'react';
import {
  FaGithubSquare,
  FaInstagram,
  FaLinkedin,
} from 'react-icons/fa';

import XIcon from './ui/XIcon';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className='bg-gray-50 border-t border-gray-200 dark:bg-gradient-to-br dark:from-background-darker dark:to-background-dark dark:border-primary/30 transition-colors duration-300'>
      <div className='max-w-[1240px] mx-auto py-16 px-4 grid lg:grid-cols-4 gap-8 text-gray-600 dark:text-gray-300'>
        {/* Brand & Socials */}
        <div className="lg:col-span-1">
          <h1 className='text-3xl font-bold bg-gradient-to-r from-secondary to-accent inline-block text-transparent bg-clip-text'>DataHelix</h1>
          <p className='py-4 text-gray-500 dark:text-gray-400 text-sm'>Helping you become an indispensable Data Professional.</p>
          <div className='flex gap-4 my-4'>
            <a href="https://www.linkedin.com/company/datahelix-io/" target="_blank" rel="noopener noreferrer" className="hover:text-secondary transition-colors">
              <FaLinkedin size={24} />
            </a>
            <a href="https://twitter.com/datahelix_io" target="_blank" rel="noopener noreferrer" className="hover:text-black dark:hover:text-white transition-colors">
              <XIcon size={24} />
            </a>
            <a href="https://www.instagram.com/vikrant__42/" target="_blank" rel="noopener noreferrer" className="hover:text-pink-600 transition-colors">
              <FaInstagram size={24} />
            </a>
            <a href="https://github.com/vikrant1995" target="_blank" rel="noopener noreferrer" className="hover:text-black dark:hover:text-white transition-colors">
              <FaGithubSquare size={24} />
            </a>
          </div>
        </div>

        {/* Platform */}
        <div>
          <h6 className='font-bold text-gray-900 dark:text-white mb-4 uppercase text-xs tracking-wider'>Platform</h6>
          <ul className="space-y-2 text-sm">
            <li><Link to="/exercises" className='hover:text-secondary transition-colors'>Courses</Link></li>
            <li><Link to="/machine-learning" className='hover:text-secondary transition-colors'>Machine Learning</Link></li>
            <li><Link to="/resources/sql-cheatsheet" className='hover:text-secondary transition-colors'>SQL Cheatsheet</Link></li>
          </ul>
        </div>

        {/* Company */}
        <div>
          <h6 className='font-bold text-gray-900 dark:text-white mb-4 uppercase text-xs tracking-wider'>Company</h6>
          <ul className="space-y-2 text-sm">
            <li><Link to="/resources/blog" className='hover:text-secondary transition-colors'>Blog</Link></li>
            <li><Link to="/faq" className='hover:text-secondary transition-colors'>FAQ</Link></li>
            <li><Link to="/contact" className='hover:text-secondary transition-colors'>Contact</Link></li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h6 className='font-bold text-gray-900 dark:text-white mb-4 uppercase text-xs tracking-wider'>Legal</h6>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy" className='hover:text-secondary transition-colors'>Privacy Policy</Link></li>
            <li><Link to="/terms" className='hover:text-secondary transition-colors'>Terms of Service</Link></li>
          </ul>
        </div>
      </div>

      {/* Copyright */}
      <div className="max-w-[1240px] mx-auto px-4 py-6 border-t border-gray-200 dark:border-gray-800 text-center text-xs text-gray-400">
        &copy; {new Date().getFullYear()} DataHelix. All rights reserved.
      </div>
    </div>
  );
};

export default Footer;